<template>
  <div
    class="mini-header-mask"
    v-if="!hidden"
  />
  <div
    class="mini-header-wrapper"
    :class="{ show: !hidden }"
  >
    <Menu
      search
      :text="text"
    />
  </div>
</template>
<script setup>
import Menu from './Menu.vue'

const props = defineProps({
  hidden: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: null
  }
})

const imageSearchDropdownRef = ref(null)

watch(() => props.isShow, (newVal) => {
  if (!newVal) {
    closeImageSearchDropdown()
  }
})

const closeImageSearchDropdown = () => {
  imageSearchDropdownRef.value.hidden()
}

defineExpose({
  closeImageSearchDropdown
})

</script>
<style lang="less" scoped>
.mini-header-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  z-index: 97;
  background-color: #052784;
}
.mini-header-wrapper {
  position: fixed;
  top: 0;
  height: 48px;
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  background-color: #052784;
  transform: translateY(-100%);
  transition: transform 0.3s ease;
  z-index: 98;

  &.show {
    transform: translateY(0);
  }
}
</style>
